export enum StorageTypeEnum {
  Database = 1,
  LocalStorage,
  DatabaseAndLocalStorage,
}

export enum StorageKeyEnum {
  User = 'user',
}
